module.exports = __webpack_public_path__ + "img/portfolio-thumbnail_portfolio.ec732d29.jpg";